module.exports = __webpack_public_path__ + "img/trolley.c73e00ac.png";